import React from 'react';
import PropTypes from 'prop-types';

const ActiveContentHeader = ({ icon, pageLabel, children, controls }) => {
  return (
    <div className="active-content-header-container">
      <div className="active-content-header">
        {icon ||
          (pageLabel && (
            <div className="active-content-header-title">
              {icon}
              <span className="icon-label ml-md-3">{pageLabel}</span>
            </div>
          ))}
        <div className="active-content-header-controls">{controls}</div>
        <div className="active-content-header-actions">{children}</div>
      </div>
    </div>
  );
};

ActiveContentHeader.propTypes = {
  icon: PropTypes.node,
};

ActiveContentHeader.defaultProps = {
  icon: null,
};

export default ActiveContentHeader;
